/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_LayoutInputs */

const cs_ebr_fact_layout = /** @type {(inputs: Ebr_Fact_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispozice`)
};

const en_ebr_fact_layout = /** @type {(inputs: Ebr_Fact_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout`)
};

/**
* | output |
* | --- |
* | "Layout" |
*
* @param {Ebr_Fact_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_layout = /** @type {((inputs?: Ebr_Fact_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_layout(inputs)
	return cs_ebr_fact_layout(inputs)
});